/*
 * @Autor: 杨华
 * @Version: 1.0
 * @Date: 2020-06-09 08:12:16
 * @LastEditors: xx
 * @Description: 设备
 * @LastEditTime: 2021-01-22 10:01:56
 */

import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/basic-sms/v1";

//短信管理列表查询
export const getSmsList = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  return request(API_URL + "/sms/opr/page", data, config);
};
//剩余可用条数top5
export const getSmsRemainTop5 = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sms/opr/remain_top5", data, config);
};
//派诺短信池数据统计
export const getSmsSysPoolStat = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sms/sys/pool_stat", data, config);
};
//短信购买
export const smsPurchase = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sms/purchase", data, config);
};
//获取运营商短信基础信息
export const getSmsOprStat = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sms/opr/stat", data, config);
};
//分页查询云产品/短信购买记录
export const getPurchasedRecordsList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sms/purchased_records/page", data, config);
};
//分页查询已发送短信
export const getSentRecordsList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sms/sent_records/page", data, config);
};
//发送短信审核
export const purchasedRecordsAudit = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sms/purchased_records/audit", data, config);
};
//保存短信套餐
export const saveSmsCombo = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sms/combo/save", data, config);
};
//获取SMS短信套餐配置集合
export const getSmsComboes = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sms/comboes", data, config);
};
//新增短信池数
export const addSmsNum = (data = {}, config: objAny = {}) => {
  config.method = "postStr";
  return request(API_URL + "/sms/pool/add_num", data, config);
};
